export default __webpack_public_path__ + "static/media/highDesk.e30adcab.svg";